<template>
  <div class="members-profile-fields-table">
    <AppScrollableTable :has-fixed-column="false">
      <AppTable
        ref="table"
        hoverable
        :loading="showLoading"
        :table-data="memberProfileFields"
      >
        <template #empty>
          <div class="mt-20 text-center">
            <img
              :src="IMAGE_EMPTY_BOX"
              class="mb-16"
              alt="Empty Box"
            >
            <h4 class="">Add custom profile fields</h4>
            <p class="text-muted">
              Create new fields to add to member<br />
              profiles
            </p>
          </div>
        </template>
        <AppTableColumn
          v-slot="{ row }"
          header="Field"
        >
          {{ row.title }}
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          header="Created by"
        >
          {{ row.created_by }}
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          header="Created on"
        >
          {{ createdOn(row) }}
        </AppTableColumn>
        <AppTableColumn v-slot="{ row }">
          <AppDropdown
            class="pull-right table-actions-dropdown"
            direction="right"
            label="Actions"
            size="small"
          >
            <AppDropdownItem @click="openEditDialog(row)">Edit</AppDropdownItem>
            <AppDropdownItem @click="openDeleteDialog(row)">Delete</AppDropdownItem>
          </AppDropdown>
        </AppTableColumn>
      </AppTable>
    </AppScrollableTable>
  </div>
</template>

<script>
import { mapInertiaProps } from '~/utils/inertia';
import { formatDate } from '~/utils/time_utils';
import dayjs from 'dayjs';
import { IMAGE_EMPTY_BOX } from '~/rails_assets';

export default {
  name: 'MemberProfileFieldsTable',
  props: {
    memberProfileFields: {
      type: Array,
      required: true,
    },
    showLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showConfirmArchiveDialog: false,
      activePolicy: null,
      IMAGE_EMPTY_BOX,
    };
  },

  computed: {
    ...mapInertiaProps({
      organization: 'organization',
    }),
  },
  methods: {
    createdOn(row) {
      return formatDate(dayjs(row.created_on));
    },
    openEditDialog(customField) {
      this.$emit('open-edit-dialog', customField);
    },
    openDeleteDialog(customField) {
      this.$emit('open-delete-dialog', customField);
    },
  },
};
</script>
